export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_09.b6c7b3a5.jpg";